import { useState } from 'react';
import './GamePage.css';

function isReactSnapPrerender() {
  return navigator.userAgent === 'ReactSnap';
}

function GamePage() {
  const [isFrameLoaded, setIsFrameLoaded] = useState(false);
  const isPrerender = isReactSnapPrerender();

  return (
    <main className="gamePage" aria-label="Игра СамВДПО">
      {(isPrerender || !isFrameLoaded) && (
        <div className="gamePage__loader" role="status" aria-live="polite">
          <span className="gamePage__loader-dot" aria-hidden="true"></span>
          <span>Загружаем игру...</span>
        </div>
      )}
      {!isPrerender && (
        <iframe
          className={`gamePage__frame ${isFrameLoaded ? 'gamePage__frame_loaded' : ''}`}
          src="/game-assets/game.html"
          title="Игра СамВДПО"
          allow="autoplay"
          onLoad={() => setIsFrameLoaded(true)}
        />
      )}
    </main>
  );
}

export default GamePage;
